<script setup lang="ts">
import type { Sector } from "~/modules/sector/models/Sector.interface";
import { SectorResource } from "~/types";

const { t } = useI18n();

defineProps<{
  sector: Sector;
}>();
const emits = defineEmits(["change"]);

function onChange() {
  emits("change");
}
</script>
<template>
  <sector-toolbar
    ref="sectorToolbar"
    primary-key="name"
    :sector="sector"
    :resource="SectorResource.USER_GROUP"
    @change="onChange"
  >
    <lxc-table-column
      prop="name"
      :label="t('table.header.label')"
      data-cy="col-label"
    />
  </sector-toolbar>
</template>
